import React, { useState, useRef, useEffect } from "react";

// const fyData = {
//   FY25: ["Q1", "Q2", "Q3", "Q4"],
//   FY26: ["Q1"],
// };

export default function FyQuarterSelect({ onChange }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // toggle dropdown open/close
  const toggleDropdown = () => setIsOpen(!isOpen);

  // close dropdown when clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


function getFYData(startFY = 2025) {
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1; // 0-based → +1

  // Determine current FY (July–June cycle)
  let currentFY;
  if (currentMonth >= 7) {
    currentFY = currentYear + 1; // e.g., Aug 2025 → FY26
  } else {
    currentFY = currentYear;     // e.g., Feb 2025 → FY25
  }

  const fyData = {};

  // Loop from given startFY till currentFY
  for (let fy = startFY; fy <= currentFY; fy++) {
    const fyLabel = `FY${fy.toString().slice(-2)}`; // 👈 only last 2 digits
    fyData[fyLabel] = [];

    const cutoffs = [
      { q: "Q1", month: 9 },  // Sep 1
      { q: "Q2", month: 12 }, // Dec 1
      { q: "Q3", month: 3 },  // Mar 1
      { q: "Q4", month: 6 }   // Jun 1
    ];

    cutoffs.forEach(({ q, month }) => {
      let unlockDate;

      if (month >= 7) {
        // belongs to FY-1 year
        unlockDate = new Date(fy - 1, month - 1, 1);
      } else {
        // belongs to FY year
        unlockDate = new Date(fy, month - 1, 1);
      }

      if (now >= unlockDate) {
        fyData[fyLabel].push(q);
      }
    });
  }

  return fyData;
}


const fyData=getFYData();
  const allFY = Object.keys(fyData);
  const allQ = Object.entries(fyData).flatMap(([fy, quarters]) =>
    quarters.map((q) => `${fy}-${q}`)
    );
  const [selected, setSelected] = useState({ FY: [...allFY], Q: [...allQ] });
  

  // handle FY select/deselect (selects all Q under it)
  const handleFyChange = (fy) => {
    let newSelected = { ...selected };

    if (newSelected.FY.includes(fy)) {
      // uncheck FY -> remove FY and its Qs
      newSelected.FY = newSelected.FY.filter((f) => f !== fy);
      newSelected.Q = newSelected.Q.filter((q) => !q.startsWith(fy + "-"));
    } else {
      // check FY -> add FY and all its Qs
      newSelected.FY.push(fy);
      newSelected.Q = [
        ...newSelected.Q.filter((q) => !q.startsWith(fy + "-")),
        ...fyData[fy].map((q) => `${fy}-${q}`),
      ];
    }
    setSelected(newSelected);
    onChange(newSelected); // send data back to parent
  };

  // Toggle Select All
const toggleAll = () => {
  const allFY = Object.keys(fyData);
  const allQ = Object.entries(fyData).flatMap(([fy, quarters]) =>
    quarters.map((q) => `${fy}-${q}`)
  );

  const isAllSelected =
    selected.FY.length === allFY.length &&
    selected.Q.length === allQ.length;

  if (isAllSelected) {
    // Deselect everything
    const newState = { FY: [], Q: [] };
    setSelected(newState);
    onChange(newState);
  } else {
    // Select everything
    const newState = { FY: [...allFY], Q: [...allQ] };
    setSelected(newState);
    onChange(newState);
  }
};


  // handle Quarter select/deselect
  const handleQChange = (fy, q) => {
    const qKey = `${fy}-${q}`;
    let newSelected = { ...selected };

    if (newSelected.Q.includes(qKey)) {
      newSelected.Q = newSelected.Q.filter((item) => item !== qKey);
    } else {
      newSelected.Q.push(qKey);
    }

    // update FY based on all quarters selected
    if (fyData[fy].every((q) => newSelected.Q.includes(`${fy}-${q}`))) {
      if (!newSelected.FY.includes(fy)) newSelected.FY.push(fy);
    } else {
      newSelected.FY = newSelected.FY.filter((f) => f !== fy);
    }

    setSelected(newSelected);
    onChange(newSelected);
  };

  // remove selected quarter when clicking "x"
  const removeSelection = (qKey) => {
    let newSelected = { ...selected };
    newSelected.Q = newSelected.Q.filter((q) => q !== qKey);

    const [fy] = qKey.split("-");
    if (!fyData[fy].every((q) => newSelected.Q.includes(`${fy}-${q}`))) {
      newSelected.FY = newSelected.FY.filter((f) => f !== fy);
    }

    setSelected(newSelected);
    onChange(newSelected);
  };

  return (
    <div className="relative w-72" ref={dropdownRef}>
      {/* Select Box */}
      {/* <div
        className="border rounded p-2 cursor-pointer bg-white"
        onClick={toggleDropdown}
      >
        {selected.Q.length === 0 ? (
          <span className="text-gray-400">Select FY & Quarters</span>
        ) : (
<div className="flex flex-wrap gap-1">
   {selected.Q.map((val) => (
              <span
                key={val}
                className="bg-blue-100 text-blue-700 px-2 py-1 rounded-full text-sm flex items-center"
              >
                {val}
                <button
                  className="ml-1 text-red-500"
                  onClick={(e) => {
                    e.stopPropagation();
                    removeSelection(val);
                  }}
                >
                  ×
                </button>
              </span>
            ))}
</div>

        )}
      </div> */}
            <div
        onClick={toggleDropdown}
        style={{
          minHeight: 40,
          border: "1px solid #ccc",
          padding: 8,
          borderRadius: 6,
          display: "flex",
          flexWrap: "wrap",
          gap: 6,
          alignItems: "center",
          cursor: "pointer",
          background: "#fff",
        }}
      >
        {selected.Q.length === 0 ? (
          <span style={{ color: "#888" }}>Select FY/Quarters...</span>
        ) : selected.FY.length === Object.keys(fyData).length &&
    selected.Q.length === Object.values(fyData).flat().length ? (
    // If everything selected, show "All" chip
    <span key='All'
      style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                padding: "4px 8px",
                background: "#f0f0f0",
                borderRadius: 12,
                fontSize: 13,
              }}>
      All
      <button
        onClick={(e) => {
          e.stopPropagation();
          toggleAll(); // clears all selection
        }}
         aria-label={`remove All`}
                style={{
                  border: "none",
                  background: "transparent",
                  cursor: "pointer",
                  fontSize: 14,
                  lineHeight: 1,
                }}
      >
        ×
      </button>
    </span>
  ):(
          selected.Q.map((val) => (
            <span
              key={val}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                padding: "4px 8px",
                background: "#f0f0f0",
                borderRadius: 12,
                fontSize: 13,
              }}
            >
              <span>{val}</span>
              <button
                onClick={(e) => {
                    e.stopPropagation();
                    removeSelection(val);
                  }}
                aria-label={`remove ${val}`}
                style={{
                  border: "none",
                  background: "transparent",
                  cursor: "pointer",
                  fontSize: 14,
                  lineHeight: 1,
                }}
              >
                ×
              </button>
            </span>
          ))
        )}
      </div>
      {/* Dropdown Menu */}
      {/* {isOpen && (
        <div className="absolutepos z-10 mt-1 w-full border rounded bg-white shadow p-2 max-h-60 overflow-y-auto">
          {Object.keys(fyData).map((fy) => (
            <div key={fy} className="mb-2">
              <label className="font-semibold block">
                <input
                  type="checkbox"
                  checked={selected.FY.includes(fy)}
                  onChange={() => handleFyChange(fy)}
                />{" "}
                {fy}
              </label>
              <div className="ml-4">
                {fyData[fy].map((q) => {
                  const qKey = `${fy}-${q}`;
                  return (
                    <label key={qKey} className="block">
                      <input
                        type="checkbox"
                        checked={selected.Q.includes(qKey)}
                        onChange={() => handleQChange(fy, q)}
                      />{" "}
                      {q}
                    </label>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      )} */}
      {/* Dropdown Menu */}
{isOpen && (
  <div className="absolutepos z-10 mt-1 w-full border rounded bg-white shadow p-2 max-h-60 overflow-y-auto">
    
    {/* Select All */}
    <label className="flex items-center space-x-2 font-semibold">
      <input
        type="checkbox"
        checked={
          selected.FY.length === Object.keys(fyData).length &&
          selected.Q.length === Object.values(fyData).flat().length
        }
        onChange={() => {
          const isAllSelected =
            selected.FY.length === Object.keys(fyData).length &&
            selected.Q.length === Object.values(fyData).flat().length;

          if (isAllSelected) {
            setSelected({ FY: [], Q: [] });
            onChange({ FY: [], Q: [] });
          } else {
            const allFY = Object.keys(fyData);
            const allQ = Object.entries(fyData).flatMap(([fy, quarters]) =>
              quarters.map((q) => `${fy}-${q}`)
            );
            setSelected({ FY: allFY, Q: allQ });
            onChange({ FY: allFY, Q: allQ });
          }
        }}
      />
      <span> Select All</span>
    </label>

    {/* FY + Quarters */}
    {Object.keys(fyData).map((fy) => (
      <div key={fy} className="mb-2">
        <label className="font-semibold block">
          <input
            type="checkbox"
            checked={selected.FY.includes(fy)}
            onChange={() => handleFyChange(fy)}
          />{" "}
          {fy}
        </label>
        <div className="ml-4">
          {fyData[fy].map((q) => {
            const qKey = `${fy}-${q}`;
            return (
              <label key={qKey} className="block">
                <input
                  type="checkbox"
                  checked={selected.Q.includes(qKey)}
                  onChange={() => handleQChange(fy, q)}
                />{" "}
                {q}
              </label>
            );
          })}
        </div>
      </div>
    ))}
  </div>
)}

    </div>
  );
}